import React, { useEffect, useState } from 'react'
import { Form, Button, Row, Col, message, Spin } from 'antd'
import { toast } from 'react-toastify'
import apiRequest from '../../hooks/apiRequest'
import SingleFileUploader from './SingleFileUploader'

const UploadDocument = props => {
  const {
    form,
    moduleId,
    documentId,
    claimId,
    ProductId,
    onSucess,
    visible,
    insurerId,
  } = props

  const { validateFields } = form
  const [moduleDocument, setModuleDocument] = useState([])
  const [claimCreationData, setClaimCreationData] = useState()
  const [loading, setLoading] = useState(false)
  const [submitDisabled, setSubmitDisabled] = useState(false)
  const [uploadedFiles, setUploadedFiles] = useState({}) //  store each doc’s file

  useEffect(() => {
    if (moduleId) {
      fetchModuleDocument(moduleId)
      fetchClaimData(claimId)
    }
  }, [visible])

  const fetchClaimData = async id => {
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL}/Claim/GetClaimById/${id}`,
        'GET'
      )
      if (response.success) {
        setClaimCreationData(response.data.result.claim_creation)
      }
    } catch (error) {
      console.error('Error fetching claim data:', error)
    }
  }


  const fetchModuleDocument = async id => {
    try {
      if (!ProductId) return
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL_DOCUMENT}/ModuleDocument/ByModule/${id}/${ProductId}`
      )
      if (!response.ok) throw new Error('Network response was not ok')
      const data = await response.json()

      const modifiedData =
        data?.data?.map(doc => ({
          ...doc,
          key: `document_${doc.documentMasterId}`,
          filePath: doc.filePath || '',
          id: doc.id || 0,
        })) || []

      setModuleDocument(modifiedData)
    } catch (error) {
      console.error('Error fetching module documents:', error)
    }
  }

  const getBase64 = file =>
    new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result.split(',')[1])
      reader.onerror = error => reject(error)
    })

  const handleSubmit = async e => {
    e.preventDefault()
    setLoading(true)

    try {
      const payload = await Promise.all(
        moduleDocument.map(async doc => {
          const file = uploadedFiles[doc.key]
          if (file) {
            const fileBase64 = await getBase64(file)
            return {
              moduleId: insurerId,
              productId: ProductId,
              documentMasterId: doc.documentMasterId,
              fileBytes: fileBase64,
              id: doc.id || 0,
              documentName: doc.documentName,
              filePath: doc.filePath || '',
              uploadedAt: new Date().toISOString(),
              active: true,
              entityType: 'claim',
              EntityId: claimCreationData?.id,
              EntityNumber: claimCreationData?.claim_number,
              InsurerId: insurerId,
            }
          }
          return null
        })
      )

      const filteredPayload = payload.filter(item => item !== null)
      if (filteredPayload.length === 0) {
        message.warning('Please upload at least one document.')
        return
      }

      const urlBase = process.env.REACT_APP_BASE_URL_DOCUMENT
      for (const item of filteredPayload) {
        const url = documentId
          ? `${urlBase}/Document/Update/${documentId}`
          : `${urlBase}/Document`
        const response = await apiRequest(url, 'POST', item)

        if (response.success) {
          toast.success('Document uploaded successfully!')
          onSucess()
        } else {
          toast.error(response.error || 'Upload failed for one document.')
        }
      }


      const url = `${process.env.REACT_APP_BASE_URL}/Claim/UpdateClaim/update-claim/${claimCreationData?.id}`
      const res = await apiRequest(url, 'POST',{ status: 6, Notes: 'All documents submitted', ApprovedAmount: 0 })

      if (res.success) {
        toast.success('Claim updated successfully.')
        window.location.href = '/claims'
      } else {
        toast.error(res.error || 'Something went wrong.')
      }


    } catch (error) {
      console.error(error)
      toast.error('Something went wrong')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="container mt-3">
      <Spin spinning={loading} size="large" />
      <div className="card p-4">
        <Form layout="vertical" onSubmit={handleSubmit}>
          <Row gutter={16}>
            {moduleDocument.map((doc, index) => (
              <Col span={12} key={index}>
                <Form.Item label={doc.documentName}>
                  <SingleFileUploader
                    onFileSelect={file => {
                      setUploadedFiles(prev => ({
                        ...prev,
                        [doc.key]: file,
                      }))
                    }}
                  />
                </Form.Item>
              </Col>
            ))}
          </Row>
          <Button
            type="primary"
            className="btn-success"
            htmlType="submit"
            disabled={submitDisabled || loading}
          >
            Submit Documents
          </Button>
        </Form>
      </div>
    </div>
  )
}

export default Form.create()(UploadDocument)
